import { useEffect, useState } from 'react';
import { findUpUntil } from '../../utils/dom';
import { useStableEventHandler } from '../use-stable-event-handler';
import ModeTracker from './mode-tracker';
var modeTracker = new ModeTracker();
function useModeObserver(elementRef, onChange) {
    var handler = useStableEventHandler(function (node) {
        if (node) {
            onChange(node);
        }
    });
    useEffect(function () {
        handler(elementRef.current);
        return modeTracker.attach({ callback: handler, element: elementRef.current });
    }, [elementRef, handler]);
}
export function useCurrentMode(elementRef) {
    var _a = useState('light'), value = _a[0], setValue = _a[1];
    useModeObserver(elementRef, function (node) {
        var darkModeParent = findUpUntil(node, function (node) { return node.classList.contains('awsui-polaris-dark-mode') || node.classList.contains('awsui-dark-mode'); });
        setValue(darkModeParent ? 'dark' : 'light');
    });
    return value;
}
export function useVisualRefresh(elementRef) {
    var _a = useState(false), value = _a[0], setValue = _a[1];
    useModeObserver(elementRef, function (node) {
        var _a, _b;
        var supportsCSSVariables = (_b = (_a = window.CSS) === null || _a === void 0 ? void 0 : _a.supports) === null || _b === void 0 ? void 0 : _b.call(_a, 'color', 'var(--test-var)');
        if (!supportsCSSVariables) {
            return;
        }
        var visualRefreshParent = findUpUntil(node, function (node) { return node.classList.contains('awsui-visual-refresh'); });
        setValue(!!visualRefreshParent);
    });
    return value;
}
//# sourceMappingURL=index.js.map